import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import DraftRepository from "../Repositories/DraftRepository";

class DraftBloc {
  rowtableChannel = new Subject();
  submitChannel = new Subject();
  eselonChannel = new Subject();
  workUnitChannel = new Subject();
  rankChannel = new Subject();
  detailChannel = new Subject();
  deleteChannel = new Subject();
  updateChannel = new Subject();
  repository = new DraftRepository();

  constructor() {
    this.rowtableChannel.next({ status: apiResponse.INITIAL });
    this.submitChannel.next({ status: apiResponse.INITIAL });
    this.detailChannel.next({ status: apiResponse.INITIAL });
    this.deleteChannel.next({ status: apiResponse.INITIAL });
    this.updateChannel.next({ status: apiResponse.INITIAL });
    this.eselonChannel.next({ status: apiResponse.INITIAL });
    this.workUnitChannel.next({ status: apiResponse.INITIAL });
    this.rankChannel.next({ status: apiResponse.INITIAL });
  }

  fetchEselon = async (query) => {
    try {
      this.eselonChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchEselon(query)
        .then((result) => {
          this.eselonChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.eselonChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {}
  };

  fetchRank = async (query) => {
    try {
      this.rankChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRank(query)
        .then((result) => {
          this.rankChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.rankChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {}
  };

  fetchWorkUnit = async (query) => {
    try {
      this.workUnitChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchWorkUnit(query)
        .then((result) => {
          this.workUnitChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.workUnitChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {}
  };
  fetchRowTable = async (query, cancelToken) => {
    try {
      this.rowtableChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDraft(query, cancelToken)
        .then((result) => {
          this.rowtableChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.rowtableChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {}
  };
  fetchSubmit = async (query, cancelToken) => {
    try {
      this.submitChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchSubmit(query, cancelToken)
        .then((result) => {
          this.submitChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.submitChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {}
  };

  fetchDetail = async (query, cancelToken) => {
    try {
      this.detailChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDetail(query, cancelToken)
        .then((result) => {
          this.detailChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.detailChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {}
  };

  fetchDelete = async (query, cancelToken) => {
    try {
      this.deleteChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDelete(query, cancelToken)
        .then((result) => {
          this.deleteChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.deleteChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {}
  };

  fetchUpdate = async (query, cancelToken) => {
    try {
      this.updateChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchUpdate(query, cancelToken)
        .then((result) => {
          this.updateChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.updateChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {}
  };
}

export default DraftBloc;
